// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const NodeIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="NodeIcon" ref={forwardedRef} {...props}>
      <g>
        <path d="m3.937 6.69 6.116-3.53 6.115 3.53v7.062l-6.115 3.53-6.116-3.53zM2.931 5.528A1 1 0 0 0 2.428 6.4v7.642a1 1 0 0 0 .503.872l6.619 3.821a1 1 0 0 0 1.006 0l6.619-3.821a1 1 0 0 0 .503-.872V6.4a1 1 0 0 0-.503-.872l-6.62-3.821a1 1 0 0 0-1.005 0z" />
      </g>
      <defs>
        <clipPath id="clip0_6754_22">
          <rect width="20" height="20" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
});

/**
 * @public
 */
export const NodeIcon = /* @__PURE__ */ Object.assign(NodeIconComponent, {
  displayName: 'NodeIcon',
});
